// extracted by mini-css-extract-plugin
var _1 = "x9CkPzKlpgxr9TaMzlhF";
export { _1 as "interactiveIcon" }
